import styled from 'styled-components'
import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledStateWrapper = styled.div`
  align-items: center;
  display: flex;
`

export const StyledStateMessage = styled.div`
  color: ${theme.colors.otterWarmBlack};
  ${Font14};
  flex: 1;
  margin-left: 10px;
`

export const StyledErrorStateMessage = styled(StyledStateMessage)`
  color: ${theme.colors.error};
`
